<template>
    <layout title="Anfrageformular" :banner="$page.props.banner" h1="Anfrage" metaDescription="Hast du Fragen zu deiner Skireise? Du kannst uns ganz einfach anrufen +49 (0) 4435 96000 oder über unser Anfrageformular erreichen. Vielen Dank für deine Anfrage." metaKeywords="SCOL, SCOL Skireisen, Skireise Hilfe, Hilfe Buchung, Reise buchen, Skireise buchen, Skifahren, Ski, Skiurlaub, Frage Buchung">
        <section id="anfrage" class="scol-section bg-light">
            <div class="container-fluid py-sm-4 py-md-0">
                <div class="text-center">
                    <!-- #TODO: Text anfragen -->
                    <h2 class="h3">Jetzt unverbindlich eine Anfrage auf Dein Wunsch-Reiseziel senden.</h2>
                </div>
            </div>
        </section>
        <section id="inquiryform" class="scol-section">
            <div class="scol-section-caption">
                <h2>Anfrageformular</h2>
            </div>

            <div class="container container-small">
                <div class="row justify-content-center">
                    <div class="col-12">
                        <div v-if="form.feedback.show" class="text-center">
                            <div class="alert alert-success" role="alert">
                                {{ form.feedback.message }}
                            </div>
                        </div>
                        <form v-if="form.show" @submit.prevent="submit()">
                            <div class="row">
                                <div class="col-sm-6 mb-3 form-floating">
                                    <div class="form-floating" :class="{ 'is-invalid': form.errors.anrede }">
                                        <select class="form-select rounded-0" :class="{ 'is-invalid': form.errors.anrede }" id="floatingSelect" v-model="form.anrede">
                                            <option value="herr">Herr</option>
                                            <option value="frau">Frau</option>
                                            <option value="divers">Divers</option>
                                        </select>
                                        <label for="floatingSelect">Anrede</label>
                                    </div>
                                    <div class="invalid-feedback" v-if="form.errors.anrede">
                                        {{ form.errors.anrede }}
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-floating mb-3" :class="{ 'is-invalid': form.errors.vorname }">
                                        <input type="text" v-model="form.vorname" class="form-control rounded-0" :class="{ 'is-invalid': form.errors.vorname }" id="floatingVorname" placeholder="Vorname" />
                                        <label for="floatingVorname">Vorname*</label>
                                    </div>
                                    <div class="invalid-feedback" v-if="form.errors.vorname">
                                        {{ form.errors.vorname }}
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-floating mb-3" :class="{ 'is-invalid': form.errors.nachname }">
                                        <input type="text" v-model="form.nachname" class="form-control rounded-0" :class="{ 'is-invalid': form.errors.nachname }" id="floatingNachname" placeholder="Nachname" />
                                        <label for="floatingNachname">Nachname*</label>
                                    </div>
                                    <div class="invalid-feedback" v-if="form.errors.nachname">
                                        {{ form.errors.nachname }}
                                    </div>
                                </div>
                            </div>
                            <div class="py-4">
                                <hr />
                            </div>

                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-floating mb-3" :class="{ 'is-invalid': form.errors.email }">
                                        <input type="email" v-model="form.email" class="form-control rounded-0" :class="{ 'is-invalid': form.errors.email }" id="floatingE-Mail" placeholder="E-Mail" />
                                        <label for="floatingE-Mail">E-Mail*</label>
                                    </div>
                                    <div class="invalid-feedback" v-if="form.errors.email">
                                        {{ form.errors.email }}
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-floating mb-3" :class="{ 'is-invalid': form.errors.telefon }">
                                        <input type="text" v-model="form.telefon" class="form-control rounded-0" :class="{ 'is-invalid': form.errors.telefon }" id="floatingTelefon" placeholder="Telefon" />
                                        <label for="floatingTelefon">Telefon</label>
                                    </div>
                                    <div class="invalid-feedback" v-if="form.errors.telefon">
                                        {{ form.errors.telefon }}
                                    </div>
                                </div>
                            </div>

                            <div class="py-4">
                                <hr />
                            </div>

                            <div class="row mt-3">
                                <div class="col-sm-6">
                                    <div class="form-floating mb-3" :class="{ 'is-invalid': form.errors.travelDate }">
                                        <input type="text" v-model="form.travelDate" class="form-control rounded-0" :class="{ 'is-invalid': form.errors.travelDate }" id="floatingTravelDate" placeholder="Reisedatum" :disabled="form.disableTravelDate === true ? true : false" />

                                        <label class="form-check-label" for="floatingTravelDate">
                                            Reiseziel & Reisedatum
                                        </label>
                                    </div>
                                    <div class="invalid-feedback" v-if="form.errors.travelDate">
                                        {{ form.errors.travelDate }}
                                    </div>
                                </div>
                                <div class="col-sm-6 mt-3 mt-sm-0">
                                    <div class="form-check">
                                        <input v-model="form.flexibel_zeitraum" class="form-check-input rounded-0" :class="{ 'is-invalid': form.errors.flexibel_zeitraum }" type="checkbox" value="" id="flexCheckFlexibelZeitraum" />
                                        <label class="form-check-label" for="flexCheckFlexibelZeitraum">
                                            <small>Ich bin flexibel in dem Zeitraum für ein anderes Reisedatum.</small>
                                        </label>
                                        <div class="invalid-feedback" v-if="form.errors.flexibel_zeitraum">
                                            {{ form.errors.flexibel_zeitraum }}
                                        </div>
                                    </div>
                                    <div class="form-check">
                                        <input v-model="form.flexibel_ziel" class="form-check-input rounded-0" :class="{ 'is-invalid': form.errors.flexibel_ziel }" type="checkbox" value="" id="flexCheckFlexibelZiel" />
                                        <label class="form-check-label" for="flexCheckFlexibelZiel">
                                            <small>Ich bin offen für das Reiseziel.</small>
                                        </label>
                                        <div class="invalid-feedback" v-if="form.errors.flexibel_ziel">
                                            {{ form.errors.flexibel_ziel }}
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-floating mb-3" :class="{ 'is-invalid': form.errors.zimmer }">
                                        <input type="text" v-model="form.zimmer" class="form-control rounded-0" :class="{ 'is-invalid': form.errors.zimmer }" id="floatingZimmer" placeholder="Wunsch Zimmer(kategorie)" />
                                        <label for="floatingZimmer">Wunsch Zimmer(kategorie)</label>
                                    </div>
                                    <div class="invalid-feedback" v-if="form.errors.zimmer">
                                        {{ form.errors.zimmer }}
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-floating mb-3" :class="{ 'is-invalid': form.errors.zimmer_anzahl }">
                                        <input type="text" v-model="form.zimmer_anzahl" class="form-control rounded-0" :class="{ 'is-invalid': form.errors.zimmer_anzahl }" id="floatingZimmerAnzahl" placeholder="Anzahl der Zimmer" />
                                        <label for="floatingZimmerAnzahl">Anzahl der Zimmer</label>
                                    </div>
                                    <div class="invalid-feedback" v-if="form.errors.zimmer_anzahl">
                                        {{ form.errors.zimmer_anzahl }}
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-floating mb-3" :class="{ 'is-invalid': form.errors.erwachsene }">
                                        <input type="text" v-model="form.erwachsene" class="form-control rounded-0" :class="{ 'is-invalid': form.errors.erwachsene }" id="floatingErwachsene" placeholder="Anzahl der Erwachsenen" />
                                        <label for="floatingErwachsene">Anzahl der Erwachsenen</label>
                                    </div>
                                    <div class="invalid-feedback" v-if="form.errors.erwachsene">
                                        {{ form.errors.erwachsene }}
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-floating mb-3" :class="{ 'is-invalid': form.errors.kinder }">
                                        <input type="text" v-model="form.kinder" class="form-control rounded-0" :class="{ 'is-invalid': form.errors.kinder }" id="floatingKinder" placeholder="Anzahl der Kinden" />
                                        <label for="floatingKinder">Anzahl der Kinder</label>
                                    </div>
                                    <div class="invalid-feedback" v-if="form.errors.kinder">
                                        {{ form.errors.kinder }}
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-floating mb-3" :class="{ 'is-invalid': form.errors.kinder_alter }">
                                        <input type="text" v-model="form.kinder_alter" class="form-control rounded-0" :class="{ 'is-invalid': form.errors.kinder_alter }" id="floatingKinderAlter" placeholder="Alter der Kinder" />
                                        <label for="floatingKinderAlter">Alter der Kinder <small class="text-muted">(Mit Komma trennen)</small></label>
                                    </div>
                                    <div class="invalid-feedback" v-if="form.errors.kinder_alter">
                                        {{ form.errors.kinder_alter }}
                                    </div>
                                </div>
                            </div>

                            <div class="py-4">
                                <hr />
                            </div>

                            <div class="row mt-3">
                                <div class="col-sm-12">
                                    <div class="form-floating" :class="{ 'is-invalid': form.errors.nachricht }">
                                        <textarea v-model="form.nachricht" class="form-control rounded-0" :class="{ 'is-invalid': form.errors.nachricht }" placeholder="Nachricht" id="floatingNachricht" style="height: 150px"></textarea>
                                        <label for="floatingNachricht">Nachricht</label>
                                    </div>
                                    <div class="invalid-feedback" v-if="form.errors.nachricht">
                                        {{ form.errors.nachricht }}
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-sm-3">
                                <div class="py-4">
                                    <hr />
                                </div>

                                <div class="col-12">
                                    <div class="form-check">
                                        <input v-model="form.datenschutz" class="form-check-input rounded-0" :class="{ 'is-invalid': form.errors.datenschutz }" type="checkbox" value="" id="flexCheckDefault" />
                                        <label class="form-check-label" for="flexCheckDefault">
                                            <small>Ich stimme zu, dass die Angaben in dem Anfrageformular
                                                inklusive der dort angegebenen Kontaktdaten zwecks
                                                Bearbeitung der Anfrage und für den Fall von
                                                Anschlussfragen bei uns gespeichert werden. Diese Daten
                                                geben wir nicht ohne Ihre Einwilligung weiter.</small>
                                        </label>
                                        <div class="invalid-feedback" v-if="form.errors.datenschutz">
                                            {{ form.errors.datenschutz }}
                                        </div>
                                    </div>
                                    <button type="submit" class="mt-4 btn btn-primary rounded-pill" :disabled="form.processing">
                                        <i class="far fa-paper-plane"></i> Anfrage senden
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    </layout>
</template>

<script>
import Layout from "./Layouts/Standard";
import "vue3-carousel/dist/carousel.css";
import { Carousel, Slide, Navigation } from "vue3-carousel";
import { useForm } from "@inertiajs/inertia-vue3";

export default {
    setup() {

        const urlParams = new URLSearchParams(window.location.search);
        const reisezielParam = urlParams.get('reiseziel');

        let holidayName = '';
        let confDisableTravelDate = false;

        if (reisezielParam) {
            confDisableTravelDate = true;
            holidayName = reisezielParam;
        }

        const form = useForm({
            show: true,
            rueckruf: null,
            flexibel_zeitraum: null,
            flexibel_ziel: null,
            anrede: null,
            vorname: null,
            nachname: null,
            email: null,
            telefon: null,
            travelDate: holidayName,
            disableTravelDate: confDisableTravelDate,
            zimmer: null,
            zimmer_anzahl: null,
            erwachsene: null,
            kinder: null,
            kinder_alter: null,
            nachricht: null,
            datenschutz: null,
            feedback: {
                show: false,
                message: "",
            },
        });

        const submit = () => {
            form.post(route('inquiry.store'), {
                onStart: () => {
                    form.feedback = {
                        show: false,
                        message: "",
                    };
                },
                onSuccess: () => {
                    form.reset();
                    form.show = false;
                    form.feedback = {
                        show: true,
                        message: "Deine Anfrage wurde versendet, vielen Dank!",
                    };
                },
                onError: () => {
                    form.feedback = {
                        show: false,
                        message: "Deine Anfrage konnte nicht versendet werden.",
                    };
                },
            });
        };

        return { form, submit };
    },
    components: {
        Layout,
        Carousel,
        Slide,
        Navigation,
        useForm,
    },
    data: () => ({
        info: {
            itemsToShow: 2,
            snapAlign: "start",
            breakpoints: {
                700: {
                    itemsToShow: 2,
                    snapAlign: "start",
                },
                1024: {
                    itemsToShow: 2,
                    snapAlign: "start",
                },
            },
        },
        galerie: {
            itemsToShow: 3,
            wrapAround: true,
            snapAlign: "start",
            arrows: true,
        },
    })
};
</script>
